export const FigmaDemo = 'CognosDemo.json';
